import { RefObject } from "react";
import { ProMessage } from "../antd";
import { filterSpaceType } from "../SearchForm/interface/baseInterface";
import { ALL_STATUS, TABLE_COLUMN_EMPTY } from "../constants/constant";
import { IObject, IRouter } from "../constants/interface";
import { TableActionType } from "../SuperTable/interface";
import { Location } from 'react-router-dom';

/**
 * 路由配置转化为数组
 * @param {array} data 路由配置
 */
 export function routeFormArray(data: IRouter[]) {
	const routesArray: IRouter[] = [];
	data.forEach(item => {
		const { children, ...route } = item;
		routesArray.push(route);
		Array.isArray(children) && routesArray.push(...routeFormArray(children));
	});
	return routesArray;
}
/**
 * 拼接带参数的路由
 * @param url 路由
 * @param params 参数
 * @returns 
 */
export function urlParamsTOUrl(url: string, params?: IObject): string {
	if (!params) return url;
	const paramsArr: string[] = [];
	for (let [key, value] of Object.entries(params)) {
		if (key && value !== undefined && value !== '' && value !== null) {
			paramsArr.push(`${key}=${value}`);
		}
	}
	return `${url}?${paramsArr.join('&')}`;
}
/**
 * 获取节点滚动了多少left和top，暂时只查找scrollTop，scrollLeft，translateX，translateY四个属性，如有其他属性需求可扩展
 * @param el 节点
 */
export function getElementScrollLeftAndTop(el: HTMLElement): {left: number, top: number} {
  const parent = el.parentNode as HTMLElement;
  const scrollTop = el.scrollTop;
  const scrollLeft = el.scrollLeft;
  const transform = el.style.transform;
  let transformX = 0;
  let transformY = 0;
  if (transform) {
    if (transform.includes('translateX')) {
      const x = transform.replace('translateX', '').replace('(', '').replace('px)', '');
      transformX = Number(x) || 0;
    }
    if (transform.includes('translateY')) {
      const y = transform.replace('translateY', '').replace('(', '').replace('px)', '');
      transformY = Number(y) || 0;
    }
  }
  if (parent && parent.tagName !== 'BODY') {
    const prevTopAndLeft = getElementScrollLeftAndTop(parent);
    // if (window.__POWERED_BY_WUJIE__ && parent.classList.contains('ant-modal-wrap')) {
    //   return {
    //     top: prevTopAndLeft.top + scrollTop - transformY - 55,
    //     left: prevTopAndLeft.left + scrollLeft - transformX - 60,
    //   };
    // }
    return {
      top: prevTopAndLeft.top + scrollTop - transformY,
      left: prevTopAndLeft.left + scrollLeft - transformX,
    };
  }
  return { top: scrollTop - transformY, left: scrollLeft - transformX, };
}
/**
 * 获取节点到页面头部和左部的距离
 * @param el 节点
 */
export function getElementTopAndLeft(el: HTMLElement): {left: number, top: number} {
  const parent = el.offsetParent as HTMLElement;
  const top = el.offsetTop;
  const left = el.offsetLeft;
  if (parent && parent.tagName !== 'BODY') {
    const prevTopAndLeft = getElementTopAndLeft(parent);
    if (window.__POWERED_BY_WUJIE__ && !window.parent.location.pathname.includes("/wmsView/wms/wes") && (
      parent.classList.contains('ant-modal-wrap') ||
      parent.classList.contains('ant-drawer')
    )) {
      return {
        top: prevTopAndLeft.top + top - 40,
        left: prevTopAndLeft.left + left - 60,
      };
    }
    return {
      top: prevTopAndLeft.top + top,
      left: prevTopAndLeft.left + left,
    };
  }
  return { top, left, };
}
/**
 * 将input光标跳到文本末尾
 * @param inputElement input节点
 * @returns 
 */
export function inputMoveEnd(inputElement?: HTMLInputElement | null) {
  if (!inputElement) return;
  inputElement.focus();
  const valueLen = inputElement.value.length;
  if (!valueLen) return;
  if (typeof inputElement.selectionStart == 'number' && typeof inputElement.selectionEnd == 'number') {
    inputElement.selectionStart = inputElement.selectionEnd = valueLen;
  }
}
/**
 * 获取节点到页面头部的距离
 * @param el 节点
 */
export function getElementTop(el: HTMLElement): number {
  if (!el) return 0;
  const parent = el.offsetParent as HTMLElement;
  const top = el.offsetTop;
  return parent && parent.tagName !== 'BODY'
    ? getElementTop(parent) + top
    : top;
}
/**
 * 过滤对象空值
 * @param obj
 */
export function filterObjEmptyValue(obj: any) {
  const newObj: any = {};
  for (let [key, value] of Object.entries(obj)) {
    if (key && value !== undefined && value !== '' && value !== null)
      newObj[key] = value;
  }
  return newObj;
}
/**
 * 判断节点是否为指定类名的子节点
 * @param children 节点
 * @param classname 类名
 * @returns 
 */
export function hasClassNameDom(
  children: HTMLElement,
  classname: string | string[],
): boolean {
  if (children.tagName === 'HTML') return false;
  if (typeof classname === 'string') {
    if (children.classList.contains(classname)) return true;
  } else {
    for (let i = 0; i < classname.length; i++) {
      const element = classname[i];
      if (children.classList.contains(element)) return true;
    }
  }
  const parentNode = children.parentNode;
  if (parentNode) return hasClassNameDom(parentNode as HTMLElement, classname);
  return false;
}
/** 全屏 */
export const requestFullScreen = (el: any) => {
  if (!el) {
    ProMessage.warning('您当前使用的浏览器不支持全屏');
    return;
  }
  if (el.requestFullscreen) {
    // W3C
    el.requestFullscreen();
  } else if (el.mozRequestFullScreen) {
    // FIREFOX
    el.mozRequestFullScreen();
  } else if (el.msRequestFullscreen) {
    //MSIE
    el.msRequestFullscreen();
  } else if (el.webkitRequestFullscreen) {
    // CHROME
    el.webkitRequestFullScreen();
  }
};

/** 退出全屏 */
export const exitFullscreen = () => {
  let de: any = document;
  if (de.exitFullscreen && isFullScreen()) {
    de.exitFullscreen();
  } else if (de.mozCancelFullScreen) {
    de.mozCancelFullScreen();
  } else if (de.msExitFullscreen) {
    de.msExiFullscreen();
  } else if (de.webkitCancelFullScreen) {
    de.webkitCancelFullScreen();
  } else if (de.webkitExitFullscreen) {
    de.webkitExitFullscreen();
  }
};
/** 判断页面是否是全屏状态 */
export const isFullScreen = () => {
  return document.fullscreenElement !== null;
};
/**
 * 过滤对象空值
 * @param obj
 */
export function filterEditObjEmptyValue(obj: any) {
  const newObj: any = {};
  for (let [key, value] of Object.entries(obj)) {
    if (key && value !== undefined && value !== null) newObj[key] = value;
  }
  return newObj;
}
/**
 * 获取文件后缀
 * @param filename 文件名
 * @returns 文件后缀
 */
export function getFileSuffix(filename: string) {
  if (typeof filename === 'string' && filename) {
    return filename.slice(filename.lastIndexOf('.'));
  }
  return '';
}
/** 过滤空值 */
export function filterEmptyValue(value: any) {
  if (value === '' || value === undefined || value === null) return TABLE_COLUMN_EMPTY;
  return value;
}
/**
 * 去除字符串的空格
 * @param str
 * @param filterType
 */
export function filterStrSpace(str: any, filterType: filterSpaceType) {
  if (typeof str === 'string') {
    switch (filterType) {
      case 'all':
        return str.replace(/\s/g, '');
      case 'both':
        return str.replace(/^\s+|\s+$/g, '');
      case 'left':
        return str.replace(/^\s+/, '');
      case 'right':
        return str.replace(/\s+$/, '');
      default:
        return str;
    }
  }
  return str;
}
/**
 * 过滤对象中的空属性和属性值的前后空格
 * @param data 对象
 * @returns
 */
export function flterEmptyAndSpace(data: any) {
  if (!data) return {};
  if (typeof data === 'object') {
    const result: any = {};
    for (let [key, value] of Object.entries(data)) {
      if (value !== undefined && value !== null && value !== '') {
        result[key] = filterStrSpace(value, 'both');
      }
    }
    return result;
  }
  return {};
}
/**
 * 数组求和
 * @param arr 数组
 */
export function arraySum(arr: number[]): number {
  var len = arr.length;
  if (len == 0) {
    return 0;
  } else if (len == 1) {
    return arr[0];
  } else {
    return arr[0] + arraySum(arr.slice(1));
  }
}
/**
 * 将普通数组转换成枚举数组
 * @param options
 * @param nameKey
 * @param valueKey
 */
export function formatToEnumItem(
  options?: any[],
  nameKey?: string,
  valueKey?: string,
): any[] {
  let result: any[] = [];
  if (Array.isArray(options) && nameKey && valueKey) {
    result = options.map(v => ({ label: v[nameKey], value: v[valueKey] }));
  }
  return result;
}
/**
 * 获取HTMLElement
 * @param container 节点id或者节点
 */
export function getHTMLElement(
  container?: HTMLElement | string,
): HTMLElement | false {
  if (!container) return false;
  if (container instanceof HTMLElement) return container;
  if (typeof container === 'string') {
    const el = document.getElementById(container);
    if (el instanceof HTMLElement) return el;
    return false;
  }
  return false;
}
/**
 * 列表头部tab切换后设置列表的参数
 * @param tableRef 列表对象
 * @param tabKey tab状态值
 * @param statusName tab状态值对应的列表搜索字段
 * @param statusListName tab状态值集合对应的列表搜索字段
 */
export function setTableStatusList(
  tableRef: RefObject<TableActionType>,
  tabKey: string,
  statusName: string,
  statusListName?: string,
): IObject {
  const params: IObject = {};
  const listName = statusListName || `${statusName}List`;
  if (tabKey !== ALL_STATUS) {
    params[statusName] = tabKey;
    params[listName] = '';
  } else {
    params[statusName] = '';
    tableRef.current?.form?.setFieldsValue({ [listName]: undefined, });
  }
  return params;
}
/**
 * 列表头部tab切换后设置列表的参数
 * @param tabKey tab状态值
 * @param statusName tab状态值对应的列表搜索字段
 */
export function setTableStatus(
  tabKey: string,
  statusName: string,
): IObject {
  const params: IObject = {
    [statusName]: tabKey !== ALL_STATUS ? tabKey : '',
  };
  return params;
}
/**
 * 获取节点到页面左部的距离
 * @param el 节点
 */
export function getElementLeft(
  el: HTMLElement,
  parentClassName?: string,
): number {
  const parent = el.offsetParent as HTMLElement;
  const left = el.offsetLeft;
  let flag: boolean = true;
  if (parentClassName) {
    flag = !parent.classList.contains(parentClassName);
  }
  return parent && parent.tagName !== 'BODY' && flag
    ? getElementLeft(parent, parentClassName) + left
    : left;
}
/**
 * 获取页面参数
 */
export function getPageQuery() {
  const paramsStr = window.location.href.split('?')[1];
  const result: any = {};
  if (paramsStr) {
    const queryArr = paramsStr.split('&');
    queryArr.forEach(v => {
      const itemArr = v.split('=');
      if (itemArr && itemArr.length === 2) {
        result[itemArr[0]] = window.decodeURIComponent(itemArr[1]);
      }
    });
  }
  return result;
}
/**
 * 页面参数转换成对象格式
 */
export function searchToObj(searchStr?: string) {
  const result: any = {};
  if (!searchStr) return result;
  const paramsStr = searchStr.startsWith('?') ? searchStr.slice(1) : searchStr;
  if (paramsStr) {
    const queryArr = paramsStr.split('&');
    queryArr.forEach(v => {
      const itemArr = v.split('=');
      if (itemArr && itemArr.length === 2) {
        result[itemArr[0]] = window.decodeURIComponent(itemArr[1]);
      }
    });
  }
  return result;
}
/**
 * pathname转换
 * @param pathname pathname
 * @param startFlag 需要被替换的字符
 * @param replaceStr 替换字符
 */
export function formatPathName(
  pathname: string,
  startFlag: string = '/',
  replaceStr: string = '_',
): string {
  if (pathname.startsWith(startFlag)) pathname = pathname.substr(1);
  return pathname.replace(/\//g, replaceStr);
}
//  根据页面路径，获取菜单节点数据
export const queryMenuNode = (pathname: string, menu: any[]) => {
  return queryTree(pathname, menu, 'path');
};
//  查找树
export const queryTree = (value: string, data: any[], valueKey = 'value') => {
  let menuNode = null;
  const getNode = (name: string, list: any[]) => {
    for (let i = 0, l = list.length; i < l; i++) {
      const item = list[i];
      if (item[valueKey] === name) {
        menuNode = item;
        return true;
      } else if (item.children) {
        const ret: boolean = getNode(name, item.children);
        if (ret) {
          return true;
        }
      }
    }
    return false;
  };
  getNode(value, data);
  return JSON.parse(JSON.stringify(menuNode));
};
//获取递归组织树
export function getTree(
  data: [],
  labelStr: string,
  valueStr: string,
  childStr: string,
) {
  const list: any = [];
  data.map((item: any) => {
    const o = {
      label: `${item[labelStr]}`,
      value: `${item[valueStr]}`,
      selectable: false,
      children:
        item[childStr] && item[childStr].length > 0
          ? getTree(item[childStr], labelStr, valueStr, childStr)
          : undefined,
    };
    list.push(o);
  });
  return list;
}
// tree数据转一维数组
export const treeToArray = (
  data: any[],
  labelKey = 'key',
  valueKey = 'title',
): any[] => {
  const dataList: any[] = [];
  const generateList = (items: any) => {
    for (let i = 0; i < items.length; i++) {
      const node = items[i];
      dataList.push({ key: node[valueKey], title: node[labelKey] });
      if (node.children) {
        generateList(node.children);
      }
    }
  };
  generateList(data);
  return dataList;
};

/** 根据子项目路由解析子项目信息 */
export function routeNameToProject(routeName: string): string | undefined {
  if (!routeName) return;
  const routeArr = routeName.split('/');
  if (routeArr.length >= 3) {
    const childrenName = routeArr[2];
    return childrenName;
  }
}
/** 根据路由解主项目一级路由 */
export function routeNameToBasePath(routeName: string): string | undefined {
  if (!routeName) return;
  const routeArr = routeName.split('/');
  if (routeArr.length >= 2) {
    const basePath = routeArr[1];
    return basePath;
  }
}
/** 将主项目路由转换成子项目路由 */
export function mainRouterToChildrenRouter(routeName: string): string | undefined {
  if (!routeName) return;
  const childrenArr = routeName.split('/').slice(3);
  return `/${childrenArr.join('/')}`;
}
/**
 * 跨项目跳转
 * @param pathname string 跳转路由（路由全称） 
 */
export function projectRouterJump(pathname: string) {
  window.$wujie?.bus.$emit('children-route-change', pathname)
}
/**
 * 拼接子项目的跳转路由
 * @param path 子项目的路由pathname
 * @param location 路由信息
 * @returns 
 */
export function getChildrenRouterPath(path: string, location: Location): any[] {
  let routerPathname: string = path;
  if (location.search) {
    routerPathname = routerPathname + location.search;
  }
  if (location.state) {
    return [routerPathname, { state: location.state, }]
  }
  return [routerPathname];
}
/**
 * 获取主工程的Window对象
 */
export function getMainWindow() {
  if (window.__POWERED_BY_WUJIE__) {
    return window.parent;
  }
  return window;
}
/**
 * 获取子项目的公共路径部分
 */
export function getChildrenPublicPath(): string {
  const pathname = getMainWindow().location.pathname?.split?.('/')?.slice(0, 3).join('/');
  return pathname || '';
}
/** 当前应用是否为应用中 */
export function isApp(): boolean {
  const val = window.__IS_APP || window.parent?.__IS_APP;
  return !!val;
}
